<template>
	<select>
		<option value="1">1</option>
		<option value="2">2</option>
		<option value="3">3</option>
		<option value="4">4</option>
		<option value="5">5</option>
	</select>
</template>

<script>
	import 'jquery-bar-rating'
	import 'jquery-bar-rating/dist/themes/fontawesome-stars.css'

	export default {
		name: "stars",
		props: ['value', 'disabled'],
		mounted() {
			let that = this

			$(this.$el).barrating({
				theme: 'fontawesome-stars',
				readonly: this.disabled,
				initialRating: this.value,
				allowEmpty: true,
				onSelect: function (value) {
					that.$emit('input', parseInt(value))
				}
			})
		},
		watch: {
			value(value) {
				$(this.$el).barrating('set', value).trigger('change');
			},
			disabled(bool) {
				$(this.$el).barrating('readonly', bool);
			}
		},
		destroyed() {
			$(this.$el).off().barrating('destroy')
		}
	}
</script>



// WEBPACK FOOTER //
// Stars.vue?f15de478